import React, { useState, useEffect } from "react";
import "./login.css";
import Logo from "../../assets/logo-alfa-tabelas.png";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { baseUrl } from "../../services/api/index";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [senha, setSenha] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [cpfCnpjError, setCpfCnpjError] = useState("");
  const [senhaError, setSenhaError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

useEffect(() => {
    let checkCount = 0;
    const maxChecks = 15; 
    const intervalTime = 200;

    const checkAutofill = () => {
      const cpfCnpjInput = document.getElementById("user_data");
      const senhaInput = document.getElementById("user_pass");

  
      if (document.activeElement === cpfCnpjInput || document.activeElement === senhaInput) {
        return; 
      }

      let cpfCnpjValue = cpfCnpjInput ? cpfCnpjInput.value : "";
      let senhaValue = senhaInput ? senhaInput.value : "";

      if (cpfCnpjValue && cpfCnpj === "") {
        userValidation(cpfCnpjValue); 
      }

      if (senhaValue && senha === "") {
        passwordValidation(senhaValue); 
      }

   
      if (cpfCnpjValue && senhaValue) {
         clearInterval(autofillChecker);
      }

      checkCount++;
      if (checkCount >= maxChecks) {
        clearInterval(autofillChecker);
      }
    };

    const autofillChecker = setInterval(checkAutofill, intervalTime);

    return () => clearInterval(autofillChecker);
  }, []); 

  function validarCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, "");
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
    let resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;

    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
    resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) resto = 0;
    return resto === parseInt(cpf.charAt(10));
  }

  function validarCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, "");
    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(0))) return false;

    tamanho += 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    return resultado === parseInt(digitos.charAt(1));
  }

  const userValidation = (value) => {
    const cleanedValue = value.replace(/\D/g, "");
    setCpfCnpj(cleanedValue);

    if (cleanedValue.length === 11) {
      if (!validarCPF(cleanedValue)) {
        setCpfCnpjError("CPF inválido.");
      } else {
        setCpfCnpjError("");
      }
    } else if (cleanedValue.length === 14) {
      if (!validarCNPJ(cleanedValue)) {
        setCpfCnpjError("CNPJ inválido.");
      } else {
        setCpfCnpjError("");
      }
    } else {
      setCpfCnpjError("CPF ou CNPJ deve conter 11 ou 14 números.");
    }
  };

  const passwordValidation = (value) => {
    setSenha(value);
    if (value.length < 6) {
      setSenhaError("A senha deve ter pelo menos 6 caracteres.");
    } else {
      setSenhaError("");
    }
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    async function makeLogin(usuario) {
      const response = await fetch(`${baseUrl}/login/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          document: usuario.cpf,
          password: usuario.password,
        }),
      });

      if (!response.ok) {
        if (response.status === 400 || response.status === 401) {
          alert("Dados inválidos.");
        } else if (response.status === 404 || response.status === 500) {
          alert("Usuário não tem cadastro.");
        } else if (response.status === 429) {
          alert("Muitas tentativas de login. Aguarde um momento e tente novamente.");
        } else {
          alert("Ocorreu um erro ao tentar fazer o login.");
        }

        return null;
      }

      const data = await response.json();

      if (data.error) {
        console.error("Erro na resposta:", data.error);
        if (response.status === 400 || response.status === 401) {
          alert("Dados inválidos.");
        } else if (response.status === 404 || response.status === 500) {
          alert("Usuário não tem cadastro.");
        } else if (response.status === 429) {
          alert("Muitas tentativas de login. Aguarde um momento e tente novamente.");
        } else {
          alert("Ocorreu um erro ao tentar fazer o login.");
        }
        return null;
      }

      return data;
    }

    const usuario = await makeLogin({ cpf: cpfCnpj, password: senha });

    if (usuario) {
      localStorage.setItem("token", usuario.access_token);
      localStorage.setItem("nome", usuario.user.full_name);
      localStorage.setItem("currentUserId", usuario.user.id);
      localStorage.setItem("userRole", usuario.user.role);
      window.location.href = "/dashboard";
    }

    setIsLoading(false);
  };

  const isFormValid = () => {
    return cpfCnpj && senha && !cpfCnpjError && !senhaError;
  };

  return (
    <div className="container-content">
      <main>
        <div className="form-container">
          <div className="image-container">
            <img src={Logo} alt="Alfa Tabelas" />
          </div>
          <h2>Entrar</h2>

          <form onSubmit={handleLogin}>
            <div className="form-space">
              <input
                type="tel"
                id="user_data"
                name="username" 
                autocomplete="username" 
                value={cpfCnpj}
                onChange={(event) => userValidation(event.target.value)}
                required
              />
              <label htmlFor="user_data">CPF ou CNPJ</label>
              {cpfCnpjError && (
                <span className="error-message">{cpfCnpjError}</span>
              )}
            </div>

            <div className="form-space">
              <input
                type={showPassword ? "text" : "password"}
                id="user_pass"
                name="password" 
                autocomplete="current-password"
                value={senha}
                onChange={(event) => passwordValidation(event.target.value)}
                required
              />
              <label htmlFor="user_pass">Senha de acesso</label>
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="bt-show-password"
              >
                <i id="eyeIcon">
                  {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                </i>
              </button>
              {senhaError && (
                <span className="error-message">{senhaError}</span>
              )}
            </div>

            <button id="acess" type="submit" disabled={!isFormValid()}>
              {isLoading ? <div className="spinner"></div> : "Entrar"}
            </button>
          </form>

          <button
            className="forgot-password-button"
            onClick={() => navigate("/reset-password")}
          >
            Esqueci minha senha
          </button>

          <p>
            Novo por aqui?{" "}
            <a
              href="https://api.whatsapp.com/send?phone=5513996025791"
              target="_blank"
              rel="noreferrer"
            >
              Entre em contato
            </a>{" "}
            conosco e obtenha seu acesso!
          </p>
        </div>
      </main>
      <footer>
        <p>
          Desenvolvido pela{" "}
          <a href="https://sejafluxo.com" target="_blank">Fluxo</a>
        </p>
      </footer>
    </div>
  );
}
